import type { DuplicateReviewSummary } from '@/hooks/usePatientMerge'

const STYLES: Record<DuplicateReviewSummary['strength'], { label: string; className: string }> = {
  strong: { label: 'Strong match', className: 'bg-[#FDECE8] text-[#C92A2A]' },
  possible: { label: 'Possible match', className: 'bg-[#FFF4E0] text-[#B26A00]' },
}

export function MatchStrengthPill({ strength }: { strength: DuplicateReviewSummary['strength'] }) {
  const { label, className } = STYLES[strength]
  return (
    <span
      className={`inline-flex rounded-full px-2 py-[3px] text-[11px] font-semibold ${className}`}
    >
      {label}
    </span>
  )
}
